import $ from "jquery";
import _ from "lodash";
import { getWidth, onResize } from "../utils/window";
 
export default function nextSection() {
   const $html = $("html");
   const $scroller = $("html, body");

   $(function() {
      if($('.nextSection').length) {
         $('.nextSection .icon').click(_.debounce((e)=>{
            let THIS = $(e.target);

            let closest = THIS.closest('.body_group');
            let next = null;

            if(closest.hasClass('-type-nextSectionArrow')) {
               closest = closest.parent().closest('.body_group');
            }

            if(closest.next().length) {
               next = closest.next();
            } else {
               closest = closest.closest('.body_section');
               next = closest.next();
            }

            scrollToElement(next);

         }, 100));

         onResize(() => {
            if(getWidth() > 1024) {
               $('.nextSection').closest('.body_column').css('display', '');
            } else {
               $('.nextSection').closest('.body_column').css('display', 'none');
            }
         });
      }

      if($('.banner .icon').length) {
         $('.banner .icon').click(_.debounce((e)=>{
            let THIS = $(e.target);

            let closest = THIS.closest('.banner');
            let next = null;

            if(closest.next().length) {
               next = closest.next();
            }

            scrollToElement(next);

         }, 100));
      }
   });

   function scrollToElement(next) {
      if(next && next.length) {
         $([document.documentElement, document.body]).animate({
            scrollTop: next.offset().top - 50
        }, 1000);
      }
   }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/nextSection.js